const URL_SEARCH_PARAMETER_NAME = 'q';

export default URL_SEARCH_PARAMETER_NAME;
